import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import createPersistedState from 'vuex-persistedstate'
import auth from './modules/auth'
import setting from './modules/setting'
import dishes from './modules/dishes'
import client from './modules/client'
import orders from './modules/orders'
import recreation from './modules/recreation'
import user from './modules/user'
import comment from './modules/comment'
import category from './modules/category'
import excursionCategory from './modules/excursionCategory'
import excursion from './modules/excursion'
import staffListWork from './modules/staffListWork'
import services from './modules/services'
import serviceOrder from './modules/serviceOrder'
import hotel from './modules/hotel'
import chain from './modules/chain'
import build from './modules/build'
import floor from './modules/floor'
import room from './modules/room'
import roomType from './modules/roomType'
import spaSalon from './modules/spaSalon'
import spaService from './modules/spaService'
import beautySalon from './modules/beautySalon'
import beautyCategory from './modules/beautyCategory'
import beautyService from './modules/beautyService'
import excursionOrder from './modules/excursionOrder'
import spaOrder from './modules/spaOrder'
import log from './modules/log'
import beautyOrder from './modules/beautyOrder'
import restaurantCategory from './modules/restaurantCategory'
import restaurant from './modules/restaurant'
import restaurantService from './modules/restaurantService'
import restaurantOrder from './modules/restaurantOrder'
import event from './modules/event'
import eventOrder from './modules/eventOrder'
import role from './modules/role'
import seniorStaffTask from './modules/seniorStaffTask'
import currency from './modules/currency'
import workType from './modules/workType'
import checkList from './modules/checkList'
import executorCost from './modules/executorCost'
import addWork from './modules/addWork'
import staffTasks from './modules/staffTasks'
import statistics from './modules/statistics'
import maxWageReduction from './modules/maxWageReduction'


Vue.use(Vuex)

export default new Vuex.Store({
    plugins:[
        createPersistedState({
            paths: ['auth']
        })
    ],
    state: {
        isPreloader: false,
        isShowSystemMessages: false,
        textSystemMessages: '',
        typeSystemMessages: '',
    },
    mutations: {
        TOGGLE_PRELOADER (state, payload) {
            state.isPreloader = payload
        },
        TOGGLE_SYSTEM_MESSAGE (state, payload) {
            state.isShowSystemMessages = payload
        },
        SET_TEXT_SYSTEM_MESSAGE (state, payload) {
            state.textSystemMessages = payload
        },
        SET_TYPE_SYSTEM_MESSAGE (state, payload) {
            state.typeSystemMessages = payload
        },
    },
    actions: {
        checkUnauthenticated ({ dispatch, commit }, error) {
            const message = (typeof error.response.data !== 'undefined') ? error.response.data.message : ''
            if (message === 'Unauthenticated.' && error.response.status === 401) {
                dispatch('auth/logout')
            } else {
                dispatch('showSystemMessage', {text:message})
            }
        },
        showSystemMessage ({ commit }, msgObj) {
            commit('SET_TEXT_SYSTEM_MESSAGE', msgObj.text)
            commit('SET_TYPE_SYSTEM_MESSAGE', msgObj.type)
            commit('TOGGLE_SYSTEM_MESSAGE', true)
        }
    },
    modules:{
        auth,
        setting,
        dishes,
        orders,
        recreation,
        user,
        category,
        excursionCategory,
        excursion,
        staffListWork,
        comment,
        services,
        serviceOrder,
        hotel,
        chain,
        build,
        floor,
        room,
        spaSalon,
        spaService,
        beautySalon,
        beautyCategory,
        beautyService,
        excursionOrder,
        spaOrder,
        client,
        beautyOrder,
        restaurantCategory,
        restaurant,
        restaurantService,
        restaurantOrder,
        event,
        eventOrder,
        role,
        log,
        seniorStaffTask,
        currency,
        workType,
        checkList,
        roomType,
        executorCost,
        addWork,
        staffTasks,
        statistics,
        maxWageReduction
    }
})
